export default __webpack_public_path__ + "static/media/bed-cushion.0a0bd3b9.webp";